import { Input } from '@material-ui/core';
import { Done } from '@material-ui/icons';
import { rhythm } from 'Themes/typography';
import React from 'react';
import styled from 'styled-components';

// border-top: 1px solid ${({ theme }) => theme.palette.blue.light};
// border-bottom: 1px solid ${({ theme }) => theme.palette.blue.light};
// font-family: ${({ theme }) => theme.typography.headerFontFamily};
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${rhythm(0.1)} 10px;
  flex: 0 0 100%;

  &:last-child {
    border-top: 0;
  }

  &:nth-child(2n) {
    border-top: 0;
  }

  @media screen and (min-width: 41.5625em) {
    flex: 1 0 7%;
  }
`;
// &:first-child,
//     &:nth-child(2n) {
//       border-top: 1px solid ${({ theme }) => theme.palette.blue.light};
//     }
const Title = styled.div`
  font-weight: 600;
  font-size: 0.75rem;
  flex: 1;
  position: relative;
`;

const CheckboxContainer = styled.div`
  text-align: right;
  width: 100%;
  flex: 0.5;
`;

const InputWrapper = styled.div`
  @media screen and (min-width: 1200px) {
    flex: 2;
  }
  flex: 1.1;
`;
const StyledMUInput = styled(Input)`
  & input {
    /* text-transform: capitalize; */
    color: #62727b;
    font-size: 14px;
    padding: 0;
  }
  // & input:first-letter {
  //   text-transform: uppercase;
  // }
`;

class SpecificationItem extends React.PureComponent {
  render() {
    return (
      <Container>
        <Title>
          <div>{this.props.title}:</div>
        </Title>

        <InputWrapper>
          <StyledMUInput
            disabled
            name={this.props.name}
            value={
              this.props.title === 'Dimmable' && Number(this.props.value)
                ? `Dimmable to ${this.props.value}%`
                : this.props.value + ' ' + this.props.unit
            }
            fullWidth
          />
        </InputWrapper>
        {/* <CheckboxContainer>
          <Done />
        </CheckboxContainer> */}
      </Container>
    );
  }
}

export default SpecificationItem;
